// var site = site || {};

(function ($) {
  powerCouplesRow = {
    formatter: $('.power-couples-row-v1')
  };

  Drupal.behaviors.powerCouplesRow = {
    get: function (key) {
      return powerCouplesRow[key];
    },

    set: function (key, val) {
      powerCouplesRow[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // moved from the html so we can actually use the cta_button input type
        $('.product.both .cta', thisFormatter).addClass('button_both');

        // Check products when L2 cache data returns - hide rows with bad/unavailable products
        $(document).on('inventory_status_stored', function () {
          $('.power-couples-row-v1 .product[data-productid]').each(function (i, prod_element) {
            var prodId = $(prod_element).attr('data-productid');
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p !== null ? p.PRODUCT_ID === prodId : false;
            })[0];
            var count_valid = 0;
            var undef;

            for (var i = 0; i < product.skus.length; i++) {
              var o_sku = $(document).data(product.skus[i].SKU_ID);

              if ((o_sku !== undef) && ((o_sku.isOrderable == 1) || (o_sku.INVENTORY_STATUS == 3) || (o_sku.INVENTORY_STATUS == 2 && Drupal.settings.display_notify_tos))) {
                count_valid++;
              }
            }
            if (count_valid === 0) {
              $(prod_element).parents('.power-couples-row-v1').remove();
              console.log('***Removed: "' + $(prod_element).parents('.power-couples-row-v1').find('h3').html() + '" due to lack of shoppable skus***');
            }
          });
        });

        // quickview slide down
        $('.btn-quickview', thisFormatter).once('template-btn-quickview').on('click', function(e) {
          e.preventDefault();
          $('#quickshop .close').trigger('click');

          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p !== null ? p.PRODUCT_ID === prodId : false;
            })[0];
            var $qs = site.quickshop.render({
              productData: product
            });
            var clickedProduct = $(this).closest('.product');
            var bottom_padding = 50;
            var speed = 500;
            var topPositionNavOffset = $('#top').height() + 40;

            // append after row
            $qs.insertAfter($(this).parents('.row')).delay(100).slideDown(speed, function () {
              var pos = $qs.position();
              var window_height = $(window).height();
              var offset = $qs.offset();
              var posY = offset.top - $(window).scrollTop();
              var clickedProductOffset = clickedProduct.offset();
              var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
              var qs_bottom_position = posY + $('#quickshop').height() + bottom_padding;

              // only scroll page if the quickshop fall within the viewable area
              if (qs_bottom_position > window_height) {
              /**
               * bottom of quickshop isn't visible, so let's formulate both options
              **/
                // option 1: place selected product near top of viewing area
                var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
                // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
                var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
                // select our best option
                var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

                // now scroll the window...
                $('body, html').scrollTo(scrollPosition, {
                  duration: speed,
                  axis: 'y'
                });
              }
            });
            // override close to remove dom node
            $qs.find('.close').off('click').on('click', function() {
              $qs.slideUp('500', function () {
                $qs.remove();
                $('.caret').addClass('hidden');
              });
            });
            // show caret
            $('.caret').addClass('hidden');
            $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').removeClass('hidden');
          }
        });
      });

      /**
     * "ADD BOTH TO BAG" functionality
    **/
      site.multiQS.startAndProcessFirstSku(context);
    }

  };
})(jQuery);
